<div class="sm:flex min-h-screen">

  <div [class.sidebar-open]="stateService.sidebarOpen()">
    <!-- 
    <app-sidebar>
    </app-sidebar> -->
    <div class="layout-mask animate-fadein" (click)="closeSidebar()"></div>

  </div>
  <div class=" flex dark:bg-black flex-1 min-w-0 h-screen flex-col min-h-screen">
    <app-header [selectedTab]="activeMenu()?.label"></app-header>

    <div class="flex flex-col flex-1 w-full  min-w-0 overflow-y-auto scrollbar-hide">
      <main class="relative p-3 flex-1 min-w-0">
        @if (navigationLoader.loading()) {
        <app-loader></app-loader>
        }
        @else {

        <router-outlet></router-outlet>
        }

      </main>
      <app-footer></app-footer>
    </div>
  </div>

</div>